export default __webpack_public_path__ + "static/media/ok.e08ce43b.svg";